import { notifications } from '@mantine/notifications';
import {
  getChequeGiroKey,
  getChequeGirosKey,
  useGetChequeGiro,
  useUpdateChequeGiro,
} from 'api-hooks/cheque-giro';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import ChequeGiroForm from './components/form';

export default function ChequeGiroView() {
  const { query } = useRouter();
  const id = query.id as string;
  const queryView = useGetChequeGiro({ id }, { enabled: !!id });
  const updateMutation = useUpdateChequeGiro();

  return (
    <ChequeGiroForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          chequeGiroId: id,
        });
        queryClient.refetchQueries(getChequeGirosKey());
        queryClient.refetchQueries(getChequeGiroKey());
        notifications.show({ message: result.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
